<template>
    <div class="language-dropdown">
        <v-menu v-model="isOpen" location="bottom end">
            <template #activator="{ props }">
                <v-btn v-bind="props" variant="text" class="pa-0 text-none">
                    <span :class="`fi fi-${selectedFlag}`"></span>
                    <v-icon class="ml-2">mdi-menu-down</v-icon>
                </v-btn>
            </template>
            <v-list>
                <v-list-item
                    v-for="lang in availableLanguage"
                    :key="lang.code"
                    @click="selectLanguage(lang.code)"
                >
                    <template #prepend >
                        <span :class="`fi fi-${lang.flag} mr-3`"></span>
                    </template>
                    <v-list-item-title>{{ lang.label }}</v-list-item-title>
                </v-list-item>
            </v-list>
        </v-menu>
    </div>
</template>

<script>
import 'flag-icons/css/flag-icons.min.css';

export default {
    name: 'LanguageDropdown',
    data() {
        return {
            selectedLanguage: 'ja_JP',
            isOpen: false,
            availableLanguage: [
                { code: 'ja_JP', label: '日本語', flag: 'jp' },
                { code: 'en_US', label: 'English', flag: 'us' },
                { code: 'id_ID', label: 'Bahasa Indonesia', flag: 'id' },
                { code: 'kr_KR', label: '한국어', flag: 'kr' }
            ]
        }
    },
    computed: {
        selectedFlag() {
            const lang = this.availableLanguage.find(l => l.code === this.selectedLanguage);
            return lang ? lang.flag : '';
        }
    },
    methods: {
        selectLanguage(code) {
            this.selectedLanguage = code;
            this.isOpen = false;
            // vue-i18nのlocaleを変更
            if (this.$i18n) {
                this.$i18n.locale = code;
            } else if (this.$root && this.$root.$i18n) {
                this.$root.$i18n.locale = code;
            }
        }
    },
    mounted() {
        const browserLang = navigator.language || navigator.userLanguage;
        if (browserLang.startsWith('ja')) {
            this.selectedLanguage = 'ja_JP';
        } else if (browserLang.startsWith('en')) {
            this.selectedLanguage = 'en_US';
        } else if (browserLang.startsWith('id')) {
            this.selectedLanguage = 'id_ID';
        }
        // 初期言語をvue-i18nに反映
        if (this.$i18n) {
            this.$i18n.locale = this.selectedLanguage;
        } else if (this.$root && this.$root.$i18n) {
            this.$root.$i18n.locale = this.selectedLanguage;
        }
    }
}
</script>

<style scoped>
</style>
